<template>
  <input v-if="options === null" disabled class="form-control" :value="titleLoad">

  <input v-else-if="disabled" disabled class="form-control" :value="value.join(', ')">

  <div v-else class="select2" @keydown.esc="close()" @click="open()" v-click-outside="close" :class="{'select2-active': toggle }">

    <div ref="section" class="select2-sections pt-1 pl-1">

      <section class="label" v-for="item in items" :key="item.__select2Id">
        <span :title="item.label">{{ item.label }}</span>
        <XIcon size="1.2x" class="ml-2 x-icon" @click.prevent.stop="removeItem(item)"/>
      </section>

      <input
        v-show="toggle"
        ref="input"
        v-model="textInput"
        class="select2-input"
        :id="id"
        :style="{ width: widthInput }"
      >
    </div>

    <div class="select2-dropdown">
      <div class="select2-dropdown-content">

        <div v-if="showActionButtons" class="select2-actions" @click.stop>
          <button class="select2-action-btn" @click.prevent.stop="selectAll">Selecionar Todos</button>
          <button class="select2-action-btn" @click.prevent.stop="clearAll">Limpar Todos</button>
          <button class="select2-action-btn select2-action-btn--primary" @click.prevent.stop="invertSelection">Inverter Seleção</button>
        </div>

        <template v-if="hasOptions">
          <section
            @click="addItem(option)"
            class="select2-options"
            v-for="option in showOptions" :key="option.__select2Id"
            :title="option.label"
          >
            {{ option.label }}
          </section>
        </template>
        <section v-else class="select2-options">
          Nenhum resultado encontrado
        </section>

      </div>
    </div>
  </div>
</template>

<script>
  import ClickOutside from 'vue-click-outside'
  import { Filter } from '@/models/filter'
  import { XIcon } from 'vue-feather-icons'

  export default {
    components: { XIcon },
    computed: {
      hasOptions() {
        return this.currentOptions.length > 0
      },
      items() {
        return this.currentOptions.filter(o => o.selectedSelect2)
      },
      showActionButtons() {
        return this.currentOptions.length >= 10
      },
      showOptions() {
        return this.currentOptions.filter(o => {
          return !o.selectedSelect2 &&
                  o.label.toLowerCase().includes(this.textInput.toLowerCase())
        })
      },
      widthInput() {
        return 5 + (this.textInput.length * 10) + 'px'
      }
    },
    created() {
      this.buildOptionsAndSetSelected()
    },
    data() {
      return {
        currentOptions: [],
        textInput: '',
        toggle: false
      }
    },
    directives: { ClickOutside },
    methods: {
      addItem(item) {
        item.selectedSelect2 = true
        this.emitSelected()
      },
      buildOptions() {
        let id = 0
        this.currentOptions = []
        this.options.forEach(v => {
          if (typeof v === 'string')
            this.currentOptions.push({ __select2Id: id++, label: v, selectedSelect2: false, value: v })
          else if (v) {
            let newOption = {...v}
            this.$set(newOption, 'selectedSelect2', false)
            newOption.__select2Id = id++
            this.currentOptions.push(newOption)
          }
        })
      },
      buildOptionsAndSetSelected() {
        if (this.options !== null) {
          this.buildOptions()
          this.setSelected()
        }
      },
      clearAll() {
        this.currentOptions.forEach(o => { o.selectedSelect2 = false })
        this.$emit('input', [])
      },
      close() {
        this.textInput = ''
        this.toggle = false
      },
      emitSelected() {
        this.$emit('input', this.currentOptions.filter(o => o.selectedSelect2).map(o => o.value))
      },
      invertSelection() {
        this.currentOptions.forEach(o => { o.selectedSelect2 = !o.selectedSelect2 })
        this.emitSelected()
      },
      open() {
        this.toggle = true
        this.$nextTick(() => {
          this.$refs.input.focus()
        })
      },
      removeItem(item) {
        item.selectedSelect2 = false
        this.emitSelected()
      },
      selectAll() {
        this.currentOptions.forEach(o => { o.selectedSelect2 = true })
        this.emitSelected()
      },
      setSelected() {
        if (Array.isArray(this.value)) {
          this.currentOptions.forEach(o => {
            o.selectedSelect2 = !!this.value.includes(o.value)
          })
        } else {
          this.currentOptions.forEach(o => {
            o.selectedSelect2 = false
          })
        }
      }
    },
    mounted() {
      this.popupItem = this.$el
    },
    name: 'Select2',
    props: {
      id: { required: false },
      disabled: { required: false, default: false },
      options: { required: true, validate: (value => Array.isArray(value) || value instanceof Filter || value === null ) },
      titleLoad: { default: 'Carregando...', type: String },
      value: { required: true }
    },
    watch: {
      options(n, v) {
        if (JSON.stringify(n) !== JSON.stringify(v))
          this.buildOptionsAndSetSelected()
      },
      value(n, v) {
        if (n !== v)
          this.setSelected()
      }
    }
  }
</script>

<style scoped lang="scss">
  .select2 {
    width: 100%;
    padding: 0;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: var(--input-text-color);
    background-color: var(--input-bg);
    background-clip: padding-box;
    border: 1px solid var(--input-border);
    border-radius: .25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;

    min-height: 32px;
    height: auto;
    cursor: pointer;
  }

  .select2-sections {
    padding: 0;
    border: 0;
    margin: 0;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    max-height: 110px;
    overflow-y: auto;
  }

  .select2-active {
    box-shadow: 0 0 5px #0099ff;
    border: 1px solid #0099ff;

    .select2-dropdown-content {
      display: block;
    }
  }

  .select2-dropdown {
    position: relative;
  }

  .select2-dropdown-content {
    display: none;
    top: 1px;
    left: 0;
    width: 100%;
    max-height: 200px;
    overflow-x: auto;
    position: absolute;
    background-color: var(--input-bg);
    min-width: 160px;
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
    padding: 0;
    margin: 0;
    z-index: 1;
  }

  .select2-actions {
    display: flex;
    gap: 4px;
    padding: 6px 8px;
    border-bottom: 1px solid var(--input-border);
    background-color: var(--input-bg);
    position: sticky;
    top: 0;
    z-index: 2;
  }

  .select2-action-btn {
    font-size: 70%;
    font-weight: 600;
    padding: 2px 8px;
    border: 1px solid var(--input-border);
    border-radius: .25rem;
    background-color: var(--input-bg);
    color: var(--input-text-color);
    cursor: pointer;
    white-space: nowrap;

    &:hover {
      background-color: var(--btn-hover-bg);
    }

    &--primary {
      background-color: #318BE3;
      color: #fff;
      border-color: #318BE3;

      &:hover {
        background-color: #2a7acc;
      }
    }
  }

  .label {
    background-color: #318BE3;
    color: #fff;

    font-size: 75%;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    vertical-align: baseline;
    border-radius: .25rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;

    padding: .25rem;
    margin: 0 .25rem .25rem 0;

    cursor: default;
    display: flex;
    flex-direction: row;
  }

  .x-icon {
    cursor: pointer;
    opacity: 0.4;
    color: black;
  }

  .x-icon:hover {
    opacity: 1;
  }

  .select2-input {
    -webkit-appearance: none;
    background: transparent;
    padding: 0 12px;
    height: 30px;
    line-height: 1.428571429;
    margin-top: 0;
    min-width: 5em;
    border: 0;
    box-sizing: border-box;
    display: inline-block;
    outline: none;
  }

  .select2-options {
    font-size: 80%;
    font-weight: 600;
    color: var(--input-text-color);
    padding-left: 8px;
    cursor: pointer;
    &:hover {
      background-color: var(--btn-hover-bg);
    }
  }

</style>
